import {NgControl} from '@angular/forms';
import {AbstractFormControlValidator} from '@shared/modules/form/common/abstracts/abstract-form-control-validator';

export abstract class AbstractFormControlValueAccessor extends AbstractFormControlValidator {
  protected _onTouch: () => void;
  protected _onChange: (value?: any) => void;

  private _value: any;
  public isDisabledControl: boolean;

  protected constructor(public ngControl: NgControl) {
    super(ngControl);
    ngControl.valueAccessor = this;
  }

  registerOnChange(fn: () => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabledControl = isDisabled;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  set value(value: any) {
    this._value = value;
  }

  get value(): any {
    return this._value;
  }
}
